/** Guards late responses across session/identity cache clearing, including manual refetches. */
let generation = 0;
export const attachmentSessionGeneration = () => generation;
export function advanceAttachmentSession() {
  generation++;
}
